import ProducerDetailsContracts from './ProducerDetailsContracts';

export default ProducerDetailsContracts;
